<template>
  <div class="modal fade" id="taskEditModal" tabindex="-1" aria-labelledby="taskEditModalLabel" data-bs-focus="false" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div v-if="task && !loading" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="taskEditModalLabel">
            Edycja zadania {{ task.numer_Przejazdu }} <span class="text-black" role="button" type="button" @click="copyTaskNumber"><i class="fas fa-copy"></i></span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="fw-bold" v-if="task.changes.length > 0 && vehicle">
            <div>
              Przepinka:
            </div>
            <span class="text-success">{{ vehicle.plateNumber }}</span>
            <span v-for="(change, index) in task.changes" :key="index">
              <span class="text-success"> <i class="fa-solid fa-arrow-right mx-1"></i> {{ change.vehicle.plateNumber }} </span>
            </span>
            <hr>
          </div>
          <div class="d-block">
            <h6 class="full-route-text">
              <span class="text-info fw-bold">ZAŁ  </span>
              <span v-text="`${task.stoppages[0]?.arrival.split('T')[1].slice(0, 5)} ${task.stoppages[0]?.acronym}`"></span>
              <span v-if="task.stoppages.length <= 2"> -> </span>
              <span v-if="task.stoppages.length > 2" v-text="`${task.stoppages.map((s, i) => i !== 0 && i !== task.stoppages.length - 1 ? `${task.stoppages[i]?.acronym} ${task.stoppages[i]?.arrival.split('T')[1].slice(0, 5)}` : '').join(' -> ')}`"></span>
              <span v-text="`${task.stoppages[task.stoppages?.length - 1]?.acronym} ${task.stoppages[task.stoppages?.length - 1]?.arrival?.split('T')[1].slice(0, 5)}`"></span>
              <span class="text-danger fw-bold">  R</span>
            </h6>
          </div>
          <CommentAdd comment-type="Task" :id="task.id" :date="task.zaladunek.split('T')[0]" />
          <TaskCellColorPicker :task="task" :date="date"/>
          <div class="alert alert-primary d-flex align-items-center alert-text mt-4" role="alert">
            <div>
              Kolory czcionki oraz tła zapiszą się automatycznie po wyborze koloru
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <div>
            <SmsButton v-if="task && !loading" :task="task"/>
          </div>
          <div>
            <a :href="`/zlecenia/${task.numer_Przejazdu}/${task.zaladunek.split('T')[0]}`" class="btn btn-primary" @click="closeModal" target="_blank">
              ZLECENIA
            </a>
          </div>
          <div>
            <button type="button" id="modal-close-btn" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
          </div>
        </div>
      </div>
      <div v-if="loading" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="taskEditModalLabel">
            Wczytywanie...
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Wczytuję dane zlecenia...
        </div>
        <div class="modal-footer">
          <button @click="loading = false" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colors from '@/modules/cells/colors'
import CommentAdd from '@/components/CommentAdd.vue'
import Swal from 'sweetalert2'
import SmsButton from '@/components/Partials/SmsNotifications/SmsButton.vue'
import emitter from '@/modules/events/emitter'
import TaskCellColorPicker from '@/components/Partials/ColorPickers/TaskCellColorPicker.vue'
import axios from 'axios'

export default {
  name: 'TaskEditModal',
  components: { TaskCellColorPicker, SmsButton, CommentAdd },
  data () {
    return {
      axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      task: null,
      vehicle: null,
      date: null,
      loading: false,
      saving: false,
      dailyStoppages: [],
      colors: colors,
      document: document,
      pollingTask: null
    }
  },
  created () {
    emitter.on('taskEditModalRequested', e => {
      this.task = e.task
      this.date = e.date

      axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.task.vehicleId}`, this.axiosConfig).then(r => {
        this.vehicle = r.data
      })
    })

    this.pollTask()
  },
  methods: {
    copyTaskNumber () {
      navigator.clipboard.writeText(this.task.numer_Przejazdu)
      Swal.fire({
        title: 'Skopiowano nr VRID',
        icon: 'success',
        toast: true,
        timer: 1000,
        showConfirmButton: false
      })
    },

    pollTask () {
      this.pollingTask = setInterval(() => {
        this.fetchCurrentTask()
      }, 10000)
    },

    async fetchCurrentTask () {
      if (this.task) {
        this.task = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}`, this.axiosConfig)).data
      }
    },

    closeModal () {
      document.querySelector('#modal-close-btn').click()
    }
  }
}
</script>

<style scoped>
.full-route-text {
  font-size: .7rem;
  font-weight: bold;
}

.alert-text {
  font-size: .7rem;
}

.updating-indicator {
  min-height: 76px;
}
</style>
